export const removeFileFromFileList = (
  index: number,
  input: HTMLInputElement,
) => {
  const dt = new DataTransfer();
  const { files } = input;
  if (!files) {
    return;
  }

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (index !== i) {
      dt.items.add(file); // here you exclude the file. thus removing it.
    }
  }
  /* Assigning data transfer object files to the 'input' variable will not write the data transfer files to it because it doesn't have the reference to the element: Instead write, */
  input.files = dt.files; // Assign the updates list
};
